import { render, staticRenderFns } from "./WebsiteForm.vue?vue&type=template&id=16cb8f9a&scoped=true&"
import script from "./WebsiteForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb8f9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16cb8f9a')) {
      api.createRecord('16cb8f9a', component.options)
    } else {
      api.reload('16cb8f9a', component.options)
    }
    module.hot.accept("./WebsiteForm.vue?vue&type=template&id=16cb8f9a&scoped=true&", function () {
      api.rerender('16cb8f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/WebsiteForm.vue"
export default component.exports